// 아래 위키의 webview interface를 호출합니다.
// https://confluence.tde.sktelecom.com/pages/viewpage.action?pageId=88554927
// 모든 함수를 wrapping하고 있지 않으며, 추가적으로 필요한 함수는 추가되어야 합니다.

interface nativeInterfaceParamsDiv {
  [key: string]: any
}

export const nativeCloseWindowDiv = (params: nativeInterfaceParamsDiv) => {
  executeNativeInterfaceDiv('closeWindow', params)
}

// 새 화면 띄우기 (외부 URL)
// {
//     urlPath: string
// };
export const nativeOpenExternalWindowDiv = (params: nativeInterfaceParamsDiv): void => {
  executeNativeInterfaceDiv('openWindow', params)
}

export const nativeOpenBrowserDiv = (params: nativeInterfaceParamsDiv): void => {
  executeNativeInterfaceDiv('openBrowser', params)
}

export function executeNativeInterfaceDiv(method: string, params: nativeInterfaceParamsDiv): void {
  if (window?.AdotWebHandler) {
    // means android
    window?.AdotWebHandler?.[method]?.(JSON.stringify(params))
  } else if (window?.webkit?.messageHandlers) {
    // means ios
    window?.webkit?.messageHandlers?.[method]?.postMessage?.(params)
  } else {
    // means local
    console.log('executeNativeInterfaceDiv:', method, params)
  }
}
